export default __webpack_public_path__ + "assets/images/3.b4d60c.png";